import script from "./CatalogDataBaseInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogDataBaseInput.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogDataBaseInput.vue?vue&type=style&index=0&id=631d4f2c&lang=scss"

const __exports__ = script;

export default __exports__